import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

// Initialize Sanity client
export const sanityClient = createClient({
  projectId: "hydzrgx2",
  dataset: "production",
  apiVersion: "2025-03-24",
  useCdn: true,
});

// Image URL Builder
const buildImageUrl = (source) => imageUrlBuilder(sanityClient).image(source);

export const urlFor = (source) => buildImageUrl(source);
